import { createFileRoute } from '@tanstack/react-router';
import { Statistics } from '@/features/insights/Statistics';

export const Route = createFileRoute('/_app/statistics')({ component: Statistics });
